import clsx from "clsx";
import { useForm as useFormHook } from "hooks";
import type { HighRiskMerchant } from 'features/ecommerce/types';
import {
    FormField,
    type OnboardingRiskAndCompliance,
    type OnboardingRiskAndComplianceForm
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    creditLimitPolicyInput,
    fraudToolsInput,
    terminationHistoryInput,
    kycProviderInput,
    refundChargebackPolicyInput,
    securityFeaturesInput,
    additionalRiskInput,
    hasCreditLimitPolicy = null,
    hasTerminationHistory = null,
    hasSsl = null,
}: Partial<HighRiskMerchant.OnboardingRiskAndCompliance>): OnboardingRiskAndCompliance => ({
    [FormField.HasCreditLimitPolicy]: hasCreditLimitPolicy,
    [FormField.HasTerminationHistory]: hasTerminationHistory,
    [FormField.HasSsl]: hasSsl,
    [FormField.CreditLimitPolicyInput]: clsx(creditLimitPolicyInput),
    [FormField.FraudToolsInput]: clsx(fraudToolsInput),
    [FormField.TerminationHistoryInput]: clsx(terminationHistoryInput),
    [FormField.KycProviderInput]: clsx(kycProviderInput),
    [FormField.RefundChargebackPolicyInput]: clsx(refundChargebackPolicyInput),
    [FormField.SecurityFeaturesInput]: clsx(securityFeaturesInput),
    [FormField.AdditionalRiskInput]: clsx(additionalRiskInput),
});

export const useForm = (onboardingRiskAndCompliance: OnboardingRiskAndComplianceForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingRiskAndCompliance,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
